import React from "react";
import styles from "styles/Footer.module.css";
import { Button, Grid2, Link, Typography } from "@mui/material";

const ProjectFooter = ({ menus }) => {

    return (
        <div className={styles.footer} style={{ padding: '0px' }}>
            <Grid2 container sx={{ mt: 5 }}>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    {/* <Typography variant="body2" sx={{ fontSize: '14px', color: '#696969' }}>
                        Version: V1.2025
                    </Typography> */}
                    <Typography variant="body2" sx={{ fontSize: '14px', color: '#252525' }}>
                        <span style={{ opacity: 0.5 }}>&copy; 2025 PwC. All rights reserved. PwC refers to india member firm and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see </span><Link target="_blank" href="https://www.pwc.com/structure" sx={{
                            color: '#000'
                        }}>www.pwc.com/structure</Link> <span style={{ opacity: 0.5 }}>for further details.</span>
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 12 }}>
                    <Link href="/privacy-policy" className={styles.footer_link} sx={{ paddingLeft: 0, opacity: 0.5 }}>Privacy Policy</Link> | <Link href="/terms-conditions" className={styles.footer_link} sx={{ opacity: 0.5 }}>Terms and Condition</Link> | <Link href="/consent-notice" className={styles.footer_link} sx={{ opacity: 0.5 }}>Consent Notice</Link>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default ProjectFooter;
